import React, { useState } from "react";
import ParticalBackground from "../../../Component/Layouts/ParticalContainer/PrticalBackground";
import { MdOutlineEdit } from "react-icons/md";

const DashHero = () => {
  const [value, setvalue] = useState(
    "Empowering Digital Success with Xperts House Tech."
  );
  const getValue = () => {
    const data = prompt("Plaese Enter Content.");
    setvalue(data);
  };

  return (
    <div className="DashHero">
      <ParticalBackground />
      <h1>{value}</h1>
      <MdOutlineEdit onClick={getValue} />
    </div>
  );
};

export default DashHero;
